
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm155.31 195.31l-184 184a16 16 0 01-22.62 0l-104-104a16 16 0 010-22.62l22.62-22.63a16 16 0 0122.63 0L216 308.12l150.06-150.06a16 16 0 0122.63 0l22.62 22.63a16 16 0 010 22.62z","opacity":".4","fill":"currentColor"}}),_c('path',{attrs:{"d":"M227.31 387.31a16 16 0 01-22.62 0l-104-104a16 16 0 010-22.62l22.62-22.63a16 16 0 0122.63 0L216 308.12l150.06-150.06a16 16 0 0122.63 0l22.62 22.63a16 16 0 010 22.62l-184 184z","fill":"currentColor"}})])
          )
        }
      }
    